import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-event-card-skeleton',
    standalone: true,
    imports: [CommonModule],
    template: `
    <div class="bg-white rounded-xl shadow-lg overflow-hidden h-full flex flex-col border border-gray-100 animate-pulse">
      <!-- Image Skeleton -->
      <div class="h-48 bg-gray-200 active-pulse w-full"></div>
      
      <!-- Content Skeleton -->
      <div class="p-6 flex flex-col flex-grow">
        <!-- Date Badge -->
        <div class="flex justify-between items-start mb-4">
          <div class="h-6 w-24 bg-gray-200 rounded"></div>
          <div class="h-6 w-20 bg-gray-200 rounded"></div>
        </div>
        
        <!-- Title -->
        <div class="h-8 w-3/4 bg-gray-200 rounded mb-4"></div>
        
        <!-- Description -->
        <div class="space-y-2 mb-6 flex-grow">
            <div class="h-4 w-full bg-gray-200 rounded"></div>
            <div class="h-4 w-5/6 bg-gray-200 rounded"></div>
            <div class="h-4 w-4/6 bg-gray-200 rounded"></div>
        </div>
        
        <!-- Meta -->
        <div class="flex gap-4 mb-6">
            <div class="h-4 w-16 bg-gray-200 rounded"></div>
            <div class="h-4 w-16 bg-gray-200 rounded"></div>
        </div>
        
        <!-- Button -->
        <div class="mt-auto">
            <div class="h-10 w-full bg-gray-200 rounded-lg"></div>
        </div>
      </div>
    </div>
  `
})
export class EventCardSkeletonComponent { }
